export function getHumanDuration(duration, full = false) {
    const durationSign = duration < 0 ? '-' : '';
    duration = Math.abs(Math.round(duration));
    const h = Math.floor(duration / 3600),
        m = Math.floor(duration % 3600 / 60),
        s = duration % 3600 % 60,
        r = [];

    (h || full) && r.push(h);
    (h || m || full) && r.push(m < 10 && r.length ? '0' + m : m);
    r.push(s < 10 && r.length ? '0' + s : s);
    return durationSign + r.join(':');
}

export function getHumanBandwidth(speed, round) {
    let types = ['б/сек', 'кб/сек', 'мб/сек', 'гб/сек', 'тб/сек'];
    if(typeof locale != 'undefined') {
        types = locale['bandwidths'];
    }

    let type = 0;
    while(speed > 1024) {
        speed /= 1024;
        type++;
    }

    if(round) {
        const fix = Math.pow(10, isNaN(round) ? 0 : round);
        speed = Math.round(speed * fix) / fix;
    } else if(speed < 10) {
        speed = Math.round(speed * 100) / 100;
    } else if(speed < 100) {
        speed = Math.round(speed * 10) / 10;
    } else {
        speed = Math.round(speed);
    }
    return speed + ' ' + types[type];
}
export function getHumanFileSize(size, round) {
    const divider = 1000;
    const fix = Math.pow(10, isNaN(round) ? 0 : round);
    let types = ['б', 'Кб', 'Мб', 'Гб', 'Тб', 'Пб', 'Эб', 'Зб', 'Иб'];
    if(typeof locale != 'undefined') {
        types = locale['bandwidths'];
    }

    let type = 0;
    while(size > divider) {
        size /= divider;
        type++;
    }

    size = Math.round(size * fix) / fix;
    return size + ' ' + types[type];
}
